import { useState, useEffect } from 'react';

export function useEngineeringData() {
  const [worklogsData, setWorklogsData] = useState([]);
  const [requestsData, setRequestsData] = useState([]);
  const [tasksData, setTasksData] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadAllData = async () => {
      const sessionId = sessionStorage.getItem('sessionId');
      
      // Skip loading if no session
      if (!sessionId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        
        const headers = {
          'x-session-token': sessionId
        };

        // Fetch all data in parallel from API
        const [worklogsRes, requestsRes, tasksRes, usersRes] = await Promise.all([
          fetch('/api/worklogs', { headers }),
          fetch('/api/requests', { headers }),
          fetch('/api/tasks', { headers }),
          fetch('/api/users', { headers })
        ]);

        // Check for authentication errors
        if (worklogsRes.status === 401 || requestsRes.status === 401) {
          sessionStorage.removeItem('sessionId');
          sessionStorage.removeItem('connectionInfo');
          window.location.reload();
          return;
        }

        // Parse JSON responses
        const worklogs = await worklogsRes.json();
        const requests = await requestsRes.json();
        const tasks = await tasksRes.json();
        const users = await usersRes.json();

        // Check for errors in responses
        if (worklogs.error) throw new Error(worklogs.error);
        if (requests.error) throw new Error(requests.error);
        if (tasks.error) throw new Error(tasks.error);
        if (users.error) throw new Error(users.error);

        setWorklogsData(worklogs.filter(row => row.id));
        setRequestsData(requests.filter(row => row.id));
        setTasksData(tasks.filter(row => row.id));
        setUsersData(users.filter(row => row.id));

        setLoading(false);
      } catch (err) {
        console.error('Error loading engineering data:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    const sessionId = sessionStorage.getItem('sessionId');
    
    // Don't try to load data if not connected
    if (!sessionId) {
      setLoading(false);
      setWorklogsData([]);
      setRequestsData([]);
      setTasksData([]);
      setUsersData([]);
      return;
    }

    loadAllData();
  }, []);

  return {
    worklogsData,
    requestsData,
    tasksData,
    usersData,
    loading,
    error
  };
}

